/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { useProjectId, useProjectUrl } from 'domain/shared/project';
import useRedmineProjectService from '../../redmineProjectService';
import { CreateForm } from 'framework/form';
import RedmineProjectForm from '../RedmineProjectForm';

const CreateRedmineProject = () => {
  const { getPrefilledData, create, getValidationSchema } = useRedmineProjectService();
  const { getSingleEntityUrl } = useProjectUrl();
  const projectId = useProjectId();

  return (
    <CreateForm
      submitFormFunc={create}
      getDataFunc={async () => getPrefilledData(projectId)}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Redmine Project">
        <RedmineProjectForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateRedmineProject;
